import { SKIN } from '../../types/enums';
import { createSkinComponent } from '../../utils/skinComponent';
import DefaultDrawerLayout from '../../components/layouts/DrawerLayout';
import GolaDrawerLayout from '../../components/skins/gola/layouts/DrawerLayout';
import NeobetDrawerLayout from '../../components/skins/neobet/layouts/DrawerLayout';

export const DrawerLayout = createSkinComponent(DefaultDrawerLayout, {
  [SKIN.GOLA]: GolaDrawerLayout,
  [SKIN.NEOBET]: NeobetDrawerLayout,
});
